// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"df3adedd","372":"9547fc71","613":"6d687572","692":"1dc843fb","718":"acdd1581","833":"e591151a","921":"ec225fcd"}[chunkId] + ".chunk.js";
};